exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goog-te-gadget {\n  color: white;\n}\n.goog-te-gadget .goog-logo-link {\n  color: white;\n}\n#google_translate_element {\n  text-align: center !important;\n}\n@media (max-width: 992px) {\nbody {\n    top: 0 !important;\n}\niframe.goog-te-banner-frame {\n    display: none !important;\n}\n}", ""]);

// exports
